import { Button, Card, Col, Form, Input, Modal, Row, Select, Switch, Table, TimePicker } from "antd"
import { useEffect, useState } from "react";
import { useGlobal } from "../../../System/Global/GlobalProvider";
import dayjs from 'dayjs'
import { get } from "../../../System/Api/API";
import { FiArrowLeft, FiArrowRight, FiEdit, FiPlus, FiTrash } from "react-icons/fi";
import '../../booking.css'
import { countryJson } from "../../../System/Global/countryJson";
import { unescapeNested } from "../../../System/Global/unescapeArray";

const AddressSection = ({type, addresses, setAddresses, client, clientKey, multiple = true, disabled=false}) => {

    const [ form ] = Form.useForm();
    const { UserData } = useGlobal();
    const [ adform ] = Form.useForm();
    const [ availableAddresses, setAvailableAddresses ] = useState([])
    // const { fetchAddresses } = useAddresses();
    const [ currentIndex, setCurrentIndex ] = useState(0)
    const [ modalVisible, setModalVisible ] = useState(false)
    
    const [ manual, setManual ] = useState(false);

    useEffect( () => {

        ( async () => {


            const addresses = unescapeNested( await get('address_book', {clientKey: UserData.clientKey}) )

            setAvailableAddresses(addresses) //await fetchAddresses(clientKey ? clientKey : client.clientKey))    
        })()

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [client])

    const updateAddress = (record) => {

        // let _address = availableAddresses.find((a) => a.abKey === v)

        let newAddresses = [...addresses];

        newAddresses[currentIndex] = {...newAddresses[currentIndex], ...record};

        if (!newAddresses[currentIndex].date) { 
            newAddresses[currentIndex].date = dayjs().format('YYYY-MM-DD')
        }
        if (!newAddresses[currentIndex].timeType) { newAddresses[currentIndex].timeType = "ASAP"}
        if (!newAddresses[currentIndex].time) { newAddresses[currentIndex].time = type === "Collection" ? dayjs('08:00', "HH:mm") : dayjs('17:00', "HH:mm")}
        
        // setSearch("")
        setAddresses(newAddresses)

    }

    const updateField = (key, value) => {

        let newAddresses = [...addresses];
        newAddresses[currentIndex] = {...newAddresses[currentIndex], [key]: value};
        setAddresses(newAddresses)
        
    }

    const AddressSelection = () => {

        useEffect( () => {

            if (addresses[currentIndex]?.name) {
                adform.setFieldsValue({
                    name:   addresses[currentIndex]?.name,
                    addressLine1: addresses[currentIndex].addressLine1,
                    addressLine2: addresses[currentIndex].addressLine2,
                    addressLine3: addresses[currentIndex].addressLine3,
                    townName: addresses[currentIndex].townName,
                    postCode: addresses[currentIndex].postCode,
                    country: addresses[currentIndex].country,
                })
            }

        }, [])

        const cols = [
            {
                title: 'Name',
                dataIndex: 'name',
                key: 'name',
            },
            {
                title: 'Address',
                render: item => {
                    
                    return (
                        <div>
                        { item.name && <span>{item.name} </span> }
                        { item.townName && <span>{item.townName} </span> }
                        { item.postCode && <span>{item.postCode} </span> }
                        </div>
                    )

                },
                key: 'ad1',
            },
        ]

        const onRowClick = (record) => {
            return {
                onClick: event => {
                    updateAddress(record)
                    setModalVisible(false)
                },
            };
        };

        const ListView = () => {

            const [ search, setSearch ] = useState("")

            return (
                <>
                <Form.Item>
                    <Input placeholder="Search addresses..." value={search} onChange={(e) => setSearch(e.target.value)}/>
                </Form.Item>

                <div>
                    <Table dataSource={
                            availableAddresses.filter( (a) => {
                                return a.name.toLowerCase().includes(search.toLowerCase())
                            })
                        } 
                        pagination={{pageSize: 5, showSizeChanger: false}}
                        size="small"
                        onRow={onRowClick}
                        rowKey="abKey" columns={cols}
                    />
                </div>
                </>
            )
        }

        const saveAddress = (values) => {

            updateAddress(values)
            setModalVisible(false)
        }

        const ManualView = () => {

            return (
                <Form form={adform} onFinish={saveAddress} layout="vertical" initialValues={{country: "United Kingdom"}}>
                    <Form.Item name="name" label="Name" rules={[
                            {
                                required: true,
                                message: 'Please enter the address name!',
                            }]}>
                        <Input />
                    </Form.Item>
                    <Form.Item name="addressLine1" label="Address" rules={[
                            {
                                required: true,
                                message: 'Please enter the address!',
                            }]}>
                        <Input />
                    </Form.Item>
                    <Form.Item name="addressLine2">
                        <Input />
                    </Form.Item>
                    <Form.Item name="addressLine3">
                        <Input />
                    </Form.Item>
                    <Row gutter={16}>
                        <Col xs={12}>
                            <Form.Item name="townName" label="Town" rules={[
                            {
                                required: true,
                                message: 'Please enter the town!',
                            }]}>
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col xs={12}>
                            <Form.Item name="postCode" label="Postcode" rules={[
                            {
                                required: true,
                                message: 'Please enter the postcode!',
                            }]}>
                                <Input />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Form.Item name="country" label="Country">
                        <Select 
                            placeholder="Select a country" 
                            showSearch
                            optionFilterProp="children"
                            filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                         >
                            { countryJson.map((c, i) => <Select.Option key={i} value={c.name}>{c.name}</Select.Option> )}
                              
                        </Select>
                    </Form.Item>

                    
                </Form>
            )
        }

        const setOpexYard = () => {

            saveAddress({
                name:           "Opex Yard",
                addressLine1:   "Avonmouth",
                townName:       "Bristol",
                postCode:       "BS10 7SD",
                country:        "United Kingdom",
            })

        }

        const setClientAddress = () => {

            saveAddress({
                name:           client.name,
                addressLine1:   client.ad1,
                addressLine2:   client.ad2,
                townName:       client.town,
                postCode:       client.pcode,
                country:        client.country,
            })

        }


        return (
            <Modal
                open={modalVisible}
                onCancel={() => setModalVisible(false)}
                onOk={() => adform.submit()}
                width={!manual ? 900 : 500}
                // title={`${type} address`}
            >
                <div style={{marginBottom: 20, padding: 10}}>

                <Switch checked={!manual} style={{marginRight: 20}} checkedChildren="Selection" unCheckedChildren="Manual" onChange={(checked) => setManual(!checked)} />
                {/* <Button onClick={() => setOpexYard()}>Opex Yard</Button> */}
                { client ? <Button style={{marginLeft: 10}} onClick={() => setClientAddress()}>{client.name}</Button> : null }
                </div>
                <div style={{padding: 20}}>
                { !manual ? <ListView /> : <ManualView />} 
                </div>

            </Modal>
        )
    }

    const RenderHeader = () => {

        return (
            <div style={{display: 'flex', alignItems: "center"}}>
                <div style={{flex: 1}}>
                    <div style={{display: 'flex', alignContent: "center", alignItems: "center"}}>
                        <div>
                            <h3 style={{marginTop: 0, marginBottom: 0}}>
                                {type}
                            </h3>
                        
                        </div>
                            <div style={{fontWeight: 'bold', marginLeft: 10, display: 'flex', alignContent: "center", alignItems: "center"}}>
                                <div style={{paddingTop: 3, marginRight: 3}}>
                                    { currentIndex > 0 && <FiArrowLeft style={{cursor: 'pointer'}} onClick={() => setCurrentIndex(currentIndex - 1)}/> }
                                </div>
                                <div>
                                    {currentIndex + 1} / {addresses.length} 
                                </div>
                                <div style={{paddingTop: 3, marginLeft: 3}}>
                                    { currentIndex + 1 !== addresses.length && <FiArrowRight style={{cursor: 'pointer'}} onClick={() => setCurrentIndex(currentIndex + 1)}/> }
                                </div>
                            </div>
                            
                        </div>
                    </div>
                <div>
                    
                    <div style={{display: 'flex', alignContent: "center", alignItems: "center"}}>
                        { multiple &&
                        <div>
                            { !disabled && currentIndex > 0 && <Button style={{marginRight: 5}} 
                                    onClick={() => { 
                                        
                                        let newAddresses = [...addresses]
                                        newAddresses.splice(currentIndex, 1)

                                        setAddresses(newAddresses); 
                                        setCurrentIndex(0) } }
                                ><FiTrash/></Button> }
                        </div> }
                        { addresses[currentIndex]?.name &&
                        <div>
                            { !disabled && <Button style={{marginRight: 5}} onClick={() => { setManual(true); setModalVisible(true) } }><FiEdit/></Button> }
                        </div> }
                        { addresses[currentIndex]?.name && multiple &&
                        <div>
                            { !disabled && 
                            <Button 
                                onClick={() => { 
                                    setAddresses([...addresses, {
                                        date: dayjs(addresses[currentIndex].date).format('YYYY-MM-DD'),
                                        time: dayjs(addresses[currentIndex].time, "HH:mm"),
                                        timeType: "ASAP"
                                    }]); 
                                    setCurrentIndex(addresses.length) } 
                                }
                            ><FiPlus/></Button>}
                        </div>}
                    </div> 
                    
                </div>
            </div> )

    }

    const RenderAddressView = () => {

        return (
            <div style={{minHeight: 20, marginBottom: 20, marginTop: 10, padding: 10}}>
                <h4 style={{margin: 0}}>{addresses[currentIndex].name}</h4>
                {addresses[currentIndex].addressLine1}, {addresses[currentIndex].townName}, {addresses[currentIndex].postCode} {addresses[currentIndex].country !== "United Kingdom" ? addresses[currentIndex].country : ""}
            </div>
        )
    }

    return (
        addresses &&
        <>
        <Card style={{marginBottom: 10, padding: 10}}>
            <div style={{border: '1px solid #F1F2F5', padding: 20}}>
            <RenderHeader />
                
            <Form form={form} layout="vertical" initialValues={{
                date: dayjs().add(type === "Delivery" ? 1 : 0, 'days').format('YYYY-MM-DD'),
                time: type === "Delivery" ? dayjs("2023-12-01 17:00") : dayjs("2023-12-01 09:00")
                }}>

                    { addresses[currentIndex]?.name ?
                    <Row gutter={16}>
                        <Col span={24}>
                            <RenderAddressView />
                        </Col>
                        <Col span={24}>
                            <Row gutter={16}>
                                <Col xs={10}>
                                    <Form.Item style={{marginBottom: 5}}>
                                        <Input disabled={disabled} id={"date"} onChange={(e) => updateField(e.target.id, e.target.value)} value={addresses[currentIndex].date} type="date" />
                                    </Form.Item>
                                </Col>
                                <Col xs={7}>
                                    <Form.Item style={{marginBottom: 10}}>
                                        <Select disabled={disabled} value={addresses[currentIndex].timeType} onChange={(v) => updateField("timeType", v)}>
                                            <Select.Option value="ASAP">ASAP</Select.Option>
                                            <Select.Option value="Timed">Timed</Select.Option>
                                        </Select>
                                    </Form.Item>
                                </Col>
                                <Col xs={7}>
                                    { addresses[currentIndex].timeType === "Timed" &&
                                    <Form.Item style={{marginBottom: 5}}>
                                        <TimePicker onChange={(e) => updateField('time', e)} value={addresses[currentIndex].time} allowClear={false} format={"HH:mm"} minuteStep={15} style={{width: '100%'}}/>
                                    </Form.Item> }
                                </Col>
                            </Row>
                            
                            <Row gutter={16}>
                                <Col xs={16}>
                                    <Form.Item style={{marginBottom: 5}}>
                                        <Input disabled={disabled} placeholder="Special instructions" value={addresses[currentIndex].instructions} id={"instructions"} onChange={(e) => updateField(e.target.id, e.target.value)} rows={2} />
                                    </Form.Item>
                                </Col>
                                <Col xs={8}>
                                    <Form.Item style={{marginBottom: 5}}>
                                        <Input disabled={disabled} placeholder="Reference" value={addresses[currentIndex].reference} id={"reference"} onChange={(e) => updateField(e.target.id, e.target.value)} rows={2} />
                                    </Form.Item>
                                </Col>
                            </Row>
                            
                        </Col>
                    </Row> 
                    :
                    
                    <div
                        onClick={() => { setManual(false); setModalVisible(true) } }
                        style={{
                            textAlign: 'center',
                            marginTop: 15,
                            paddingTop: 25,
                            paddingBottom: 25,
                            backgroundColor: '#F1F2F5',
                            fontSize: 16,
                            cursor: 'pointer',
                        }}
                    >
                        Enter Address
                    </div>
                    }
                
                
                
            </Form>
            </div>
        </Card>
        <AddressSelection />
        </>
    )
}

export default AddressSection;